<template>
    <section class="p-80-15 d-flex f-d-c gap80">

        <header>
            <label>Additionall Info</label>
            <h2 class="max-w-648">Enter your details and get access to all the goodies</h2>
        </header>

        <div class="container formWrapper shadow-box">

            <form id="frontpageQuote" :action="home_url+'quotes/submit/new'+(loadedInIframe?'?ref_ga=popup':'')" novalidate="novalidate" method="post" enctype="multipart/form-data" >
                
                <input v-if="ref_ads" type="hidden" v-model="ref_ads" name="ref_ads" />
                <input v-if="ref_from" type="hidden" v-model="ref_from" name="ref_from" />
                <input type="hidden" v-model="recaptcha_token" name="recaptcha_token" />
                <input type="hidden" :value="state.message" name="message" />

                <div class="f-cols">
                    <div class="f-col">

                        <div class="q-input-line">
                            <label for="first-name">First Name</label>
                            <input type="text" id="first-name" name="first_name" v-model="state.first_name" placeholder="First Name" :class="{invalid: v$.first_name.$error,qvalid: !v$.first_name.$error && state.first_name}" />
                            <span v-if="v$.first_name.$error" class="validate-text animated">{{ v$.first_name.$errors[0].$message }}</span>
                        </div>
                        
                        <div class="q-input-line">
                            <label for="last-name">Last Name</label>
                            <input type="text" id="last-name" name="last_name" v-model="state.last_name" placeholder="Last Name" :class="{invalid: v$.last_name.$error,qvalid: !v$.last_name.$error && state.last_name}" />
                            <div v-if="v$.last_name.$error" class="form-message animated">
                                <span class="validate-text">
                                    {{ v$.last_name.$errors[0].$message }}
                                </span>
                            </div>
                        </div>
            
                        <div class="q-input-line mb24">
                            <label for="email">Email</label>
                            <input type="email" id="email" name="email" v-model="state.email" placeholder="E-mail" :class="{invalid: v$.email.$error,qvalid: !v$.email.$error && state.email}" :readonly="logged_in" />
                            <div v-if="v$.email.$error" class="form-message animated">
                                <span class="validate-text">{{ v$.email.$errors[0].$message }}</span>
                            </div>
                        </div>
            
                        <div class="q-input-line">
                            <label for="company">Country</label>
                            <vue-select v-model="state.country" :options="support_countries" label-by="name" :close-on-select="true" :searchable="true" :clear-on-select="true" :class="{invalid: v$.country.$error,qvalid: !v$.country.$error && state.country}">
                                <template #label="{ selected }">
                                    <template v-if="selected">
                                        <div>
                                            <CountryFlag :country="selected.flag2" size="normal" />
                                            {{ selected.name }}
                                        </div>
                                    </template>
                                </template>
                                <template #dropdown-item="{ option }">
                                    <div>
                                        <CountryFlag :country="option.flag2" />
                                        {{ option.name }}
                                    </div>
                                </template>
                            </vue-select>
                    
                            <input type="hidden" name="country" v-model="selected_country" />
                            <div v-if="v$.country.$error" class="form-message animated">
                                <span class="validate-text">
                                    {{ v$.country.$errors[0].$message }}
                                </span>
                            </div>
                        </div>

                        <div class="q-input-line">
                            <label for="company">Company</label>
                            <input type="text" name="company" id="company" v-model="state.company" placeholder="Company" autocomplete="off" :class="{invalid: v$.company.$error,qvalid:!v$.company.$error && state.company,}" />
                            <div v-if="v$.company.$error" class="form-message animated">
                                <span class="validate-text">
                                    {{ v$.company.$errors[0].$message }}
                                </span>
                            </div>
                        </div>

                        <template v-if="!logged_in">

                            <div class="q-input-line mb24">
                                <div class="checkSwitch">
                                    <input id="create_acc" type="checkbox" v-model="state.create_acc" name="create_acc" />
                                    <label for="create_acc">
                                        Also create an account for me.
                                        <div class="custom-tooltip">
                                            <svg viewBox="0 0 24 25"><use xlink:href="#info"></use></svg>
                                            <span class="tooltiptext">You will need an account to access SDK download section and trial/production license generators.</span>
                                        </div>
                                    </label>
                                </div>
                            </div>

                            <transition-group name="register-element">
                                
                                <div class="q-input-line mb24" key="register5" style="--i: 1" v-if="state.create_acc">
                                    <label for="password">Password</label>
                                    <input type="password" name="password" id="password" v-model="state.password" placeholder="Password" autocomplete="off" :class="{invalid: v$.password.$error,qvalid:!v$.password.$error && state.password}" />
                                    <div v-if="v$.password.$error" class="form-message animated">
                                        <span class="validate-text">{{ v$.password.$errors[0].$message }}</span>
                                    </div>
                                </div>

                                <div class="q-input-line" key="register3" style="--i: 2" v-if="state.create_acc">
                                    <label for="confirm_password">Confirm Password</label>
                                    <input autocomplete="off" type="password" name="confirm_password" id="confirm_password" v-model="state.confirm_password" placeholder="Confirm Password"  :class="{invalid: v$.confirm_password.$error,qvalid: !v$.confirm_password.$error && state.confirm_password}"  />
                                    <div v-if="v$.confirm_password.$error" class="form-message animated">
                                        <span class="validate-text">{{ v$.confirm_password.$errors[0].$message }} </span>
                                    </div>
                                </div>
                                
                            </transition-group>
                        </template>
                        
                        <template v-if="!logged_in && state.create_acc">

                            <div class="q-input-line mb24">
                                <div class="checkSwitch">
                                    <input id="create_license" type="checkbox" v-model="state.create_license" name="create_license" />
                                    <label for="create_license">
                                        Create a trial license for the selected platforms.
                                    </label>
                                </div>
                            </div>


                            <template v-if="state.create_acc === true && state.create_license === true">
                                <transition-group name="register-element2" style="--total: 2">
                                    <div :class="{'q-input-line':1,'mb20':v$.app_name.$error}" style="--i: 1" key="appNameKey">
                                        <label for="app_name">App Name</label>
                                        <input type="app_name" name="app_name" id="app_name" v-model="state.app_name" placeholder="bundle ID" autocomplete="off" :class="{invalid: state.create_license === true && v$.app_name.$error,qvalid:!v$.app_name.$error && state.app_name && state.create_license === true}" />
                                        <div v-if="v$.app_name.$error" class="form-message animated">
                                            <span class="validate-text">
                                                {{ v$.app_name.$errors[0].$message }}
                                            </span>
                                        </div>
                                        <small class="info">A bundle ID or bundle identifier uniquely identifies an application in Apple's ecosystem. This means that no two applications can have the same bundle identifier. (Ex: com.barcodescanner.free)</small>
                                    </div>
                                </transition-group>
                            </template>
                        </template>
                    </div>
                    <div class="f-col">
                        
                        <div class="q-input-line mb24">
                            <label for="number_of_apps">Number of apps</label>
                            <input type="number" id="number_of_apps" name="number_of_apps" v-model="state.number_of_apps" placeholder="Ex: 1" :class="{invalid: v$.number_of_apps.$error,qvalid: !v$.number_of_apps.$error && state.number_of_apps}" />
                            <small class="info">* Number of apps that you want to support with barcode scanning SDK</small>
                            <span v-if="v$.number_of_apps.$error" class="validate-text animated">{{ v$.number_of_apps.$errors[0].$message }}</span>
                        </div>
                        <div class="q-input-line mb24">
                            <label for="number_of_devices">Number of devices</label>
                            <input type="number" id="number_of_devices" name="number_of_devices" v-model="state.number_of_devices"  placeholder="Ex: 50" :class="{invalid: v$.number_of_devices.$error,qvalid: !v$.number_of_devices.$error && state.number_of_devices}" />
                            <small class="info">* Number of devices that will utilize the barcode scanning function of your app within a year</small>
                            <span v-if="v$.number_of_devices.$error" class="validate-text animated">{{ v$.number_of_devices.$errors[0].$message }}</span>
                        </div>
                        
                        <div class="q-input-line mb24">
                            <label class="mb10">Type of app</label>
                            <div class="d-flex f-wrap-w gap20">
                                <div class="checkSwitch">
                                    <input id="app_type_ent" type="checkbox" v-model="state.type_of_app" value="Enterprise" name="type_of_app[]" />
                                    <label for="app_type_ent">
                                        Enterprise
                                        <div class="custom-tooltip">
                                            <svg viewBox="0 0 24 25"><use xlink:href="#info"></use></svg>
                                            <span class="tooltiptext">Any professional app for B2B, B2E, B2G or even B2C use that requires paid or other kind of controlled access, distributed either  publicly or privately.</span>
                                        </div>
                                    </label>
                                </div>
                                <div class="checkSwitch">
                                    <input id="app_type_con" type="checkbox" v-model="state.type_of_app" value="Consumer" name="type_of_app[]" />
                                    <label for="app_type_con">
                                        Consumer
                                        <div class="custom-tooltip">
                                            <svg viewBox="0 0 24 25"><use xlink:href="#info"></use></svg>
                                            <span class="tooltiptext">Any B2C app for personal use, freely & publicly distributed to individual consumers.</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <span v-if="v$.type_of_app.$error" class="validate-text animated">{{ v$.type_of_app.$errors[0].$message }}</span>
                        </div>

                        <div class="q-input-line mb24">
                            <label for="descArea">Description</label>
                            <textarea id="descArea" name="description" placeholder="General project info" rows="10" v-model="state.description" :class="{invalid: v$.description.$error,qvalid: !v$.description.$error && state.description}"></textarea>
                            <div v-if="v$.description.$error" class="form-message animated">
                                <span class="validate-text">
                                    {{ v$.description.$errors[0].$message }}
                                </span>
                            </div>
                        </div>
                        
                        <div class="q-input-line mb24">
                            <label class="mb10">Will your app have any kind of access restrictions such as prepaid logins, subscriptions or other kinds of controlled access</label>

                            <div class="d-flex f-wrap-w gap20">
                                <div class="checkSwitch radio">
                                    <input id="access_restrictions_yes" type="radio" v-model="state.access_restrictions" value="Yes" name="access_restrictions" />
                                    <label for="access_restrictions_yes">Yes</label>
                                </div>
                                <div class="checkSwitch radio">
                                    <input id="access_restrictions_no" type="radio" v-model="state.access_restrictions" value="No" name="access_restrictions" />
                                    <label for="access_restrictions_no">No</label>
                                </div>
                            </div>

                            <span v-if="v$.access_restrictions.$error" class="validate-text animated">{{ v$.access_restrictions.$errors[0].$message }}</span>
                        </div>

                        <div v-if="preselectedMessagePlatforms" class="q-input-line">
                            <label for="message">Message</label>
                            <div class="preselectedMessagePlatforms" v-html="preselectedMessagePlatforms"></div>
                        </div>

                        <div class="q-input-line">
                            <label for="company">How did you hear about us?</label>
                            <vue-select v-model="state.heard_about_us" :options="heard_about_us_options" :close-on-select="true" :clear-on-select="true" :class="{invalid: v$.heard_about_us.$error,qvalid: !v$.heard_about_us.$error && state.heard_about_us}"></vue-select>
                            <input type="hidden" name="heard_about_us" v-model="state.heard_about_us" />
                            <div v-if="v$.heard_about_us.$error" class="form-message animated">
                                <span class="validate-text">
                                    {{ v$.heard_about_us.$errors[0].$message }}
                                </span>
                            </div>
                        </div>

                        <div class="d-flex f-d-c f-ai-r padding-top-24">
                            <label for="company">&nbsp;</label>
                            <RecaptchaV2
                                class="captcha"
                                @widget-id="handleWidgetId"
                                @error-callback="handleErrorCalback"
                                @expired-callback="handleExpiredCallback"
                                @load-callback="handleLoadCallback"
                            />

                            <span v-if="v$.recaptcha_token.$error" class="validate-text animated">{{ v$.recaptcha_token.$errors[0].$message }}</span>
                        </div>
                        <div v-if="form_submitting" class="q-input-line submitting">
                            Submitting...
                            <div class="loadingBars">
                                <div class="rect1"></div>
                                <div class="rect2"></div>
                                <div class="rect3"></div>
                                <div class="rect4"></div>
                                <div class="rect5"></div>
                            </div>
                        </div>
                        <div v-else class="d-flex f-j-e">
                            <button type="submit" class="button link red" @click.prevent="submitForm">
                                Submit
                                <svg viewBox="0 0 20 20"><use xlink:href="#arrow_right"></use></svg>
                            </button>
                        </div>
                    </div>
                </div>


            </form>
        </div>
    </section>
</template>

<script>
import { ref, reactive, computed } from "vue";
import useValidate from "@vuelidate/core";
import {
    required,
    integer,
    minLength,
    email,
    sameAs,
    helpers,
    requiredIf,
    sameAsPassword
} from "@vuelidate/validators";
import VueNextSelect from "vue-next-select";
// import "vue-next-select/dist/index.min.css";
import CountryFlag from "vue-country-flag-next";
import { HOME_URL, ENV ,WEB_USERNAME, WEB_PASS } from "../constants/envrionment";
import { RecaptchaV2, useRecaptcha } from "vue3-recaptcha-v2";



var general_config = require('../assets/general_config');

export default {
    components: {
        "vue-select": VueNextSelect,
        CountryFlag,
        RecaptchaV2,
    },
    props: [
        'logged_in',
        'selected_barcodes',
        'selected_technologies',
    ],
    setup(props) {

        const state = reactive({
            recaptcha_token: "",
            first_name: "",
            last_name: "",
            email: "",
            description: "",
            number_of_apps: "",
            password: "",
            confirm_password: "",
            app_name: "",
            type_of_app: [],
            country: "",
            company: '',
            heard_about_us: '',
            access_restrictions: 'No',
            number_of_devices: '',
            message: '',
            create_acc: !props.logged_in?true:false,
            create_license: false
        });

        const rules = computed(() => {

            let account_rules = {},
                required_rules = {
                    recaptcha_token: {
                        required: helpers.withMessage("You must prove that you are not a robot - check the reCAPTCHA box.", required),
                    },
                    first_name: {
                        required: helpers.withMessage("The First Name is required", required),
                    },
                    last_name: {
                        required: helpers.withMessage("The Last Name is required", required),
                    },
                    description: {
                        required: helpers.withMessage("The Description field is required", required),
                    },
                    message: {
                        required: helpers.withMessage("Select atleast one Platform, Framework or Symbology", required),
                    },
                    access_restrictions: {
                        required: helpers.withMessage("The Access Restrictions field is required", required),
                    },
                    type_of_app: {
                        required: helpers.withMessage("Choose one of the provided options from the Type of app section", required),
                    },
                    number_of_apps: {
                        required: helpers.withMessage("The Number of apps field is required", required),
                        integer: helpers.withMessage("The Number of apps field only accepts integer values", integer),
                    },
                    number_of_devices: {
                        required: helpers.withMessage("The Number of devices field is required", required),
                        integer: helpers.withMessage("The Number of devices field only accepts integer values", integer),
                    },
                    email: {
                        required: helpers.withMessage("The E-mail field is required", required),
                        email: helpers.withMessage("The E-mail field must contain a valid email address",email),
                    },
                    company: {
                        required: helpers.withMessage("The Company field is required", required),
                    },
                    country: {
                        required: helpers.withMessage("The Country field is required", required),
                    },
                    heard_about_us: {
                        required: helpers.withMessage("This How did you hear about us field is required", required),
                    },
                }

            if(!props.logged_in){

                account_rules = {
                    password: {
                        required: helpers.withMessage("Password is required", requiredIf(function (form) {
                            return this.state.create_acc == true;
                        })),
                        minLength: helpers.withMessage("The length must be minimum 6 characters",minLength(6)),
                    },
                    confirm_password: {
                        required: helpers.withMessage("Please confirm your password", requiredIf(function (form) {
                            return this.state.create_acc == true;
                        })),
                        // sameAsPassword: helpers.withMessage("Passwords don't match",sameAs(state.password)),
                    },
                    app_name: {
                        required: helpers.withMessage("This bundle ID is required", requiredIf(function (form) {
                            return this.state.create_license == true && this.state.create_acc == true;
                        })),
                    },

                }

                if(state.create_acc){
                    account_rules['confirm_password']['sameAsPassword'] = helpers.withMessage("Passwords don't match",sameAs(state.password))
                }
            }

            return {
                ...required_rules,
                ...account_rules
            }
        })
        
        const v$ = useValidate(rules, state);
        const search_country = ref(null);
        const support_countries = general_config.support_countries;
        
        return {
            home_url: HOME_URL,
            state,
            v$,
            support_countries,
            heard_about_us_options : ['Web Search','Friend(s)','Youtube','Social Networks'],
            search_country,
            recaptcha_token: ref(''),
            ref_ads: ref(''),
            ref_from: ref(''),
            form_submitting : ref(false),
            loadedInIframe: ref(window.self !== window.top),
            recaptcha: useRecaptcha(),
        };
    },
    computed: {
        preselectedMessagePlatforms() {

            let res = '';
            
            if(this.selected_technologies.length || this.selected_barcodes.length){
                
                res = "I am interested in the following technologies:<br />---------------------------------------<br />";

                if(this.selected_technologies.length){
                    res += "Platform(s) / Framework(s): " + this.selected_technologies.join(', ') + "<br />";
                }
                if(this.selected_barcodes.length){
                    res += "Symbologies: " + this.selected_barcodes.join(', ') + "<br />";
                }
            }

            this.state.message = res;

            return res;
        },
        selected_country() {
            return (this.state.country)?(this.state.country.flag2).toUpperCase():''
        },
    },
    methods: {
        submitForm() {

            let self = this

            this.v$.$validate();
            
            if (this.v$.$error) {
                
                let errors = []

                for(let i = 0; i < this.v$.$errors.length; i++){

                    let o = this.v$.$errors[i]

                    errors.push('<p>'+o.$message+'</p>')
                }

                errors = errors.join('');

                $.append_notification("error", errors)
            }
            else{

                this.generateRecaptchaToken()

                self.form_submitting = true;

                try {

                    let post_params = {
                        first_name          : self.state.first_name,
                        last_name           : self.state.last_name,
                        email               : self.state.email,
                        description         : self.state.description,
                        number_of_apps      : self.state.number_of_apps,
                        password            : self.state.password,
                        confirm_password    : self.state.confirm_password,
                        company             : self.state.company,
                        country             : self.selected_country,
                        message             : self.state.message,
                        number_of_devices   : self.state.number_of_devices,
                        type_of_app         : self.state.type_of_app,
                        access_restrictions : self.state.access_restrictions,
                        heard_about_us      : self.state.heard_about_us,
                        app_name            : self.state.app_name,
                        recaptcha_token     : self.state.recaptcha_token,
                        ref_ads             : self.ref_ads,
                        ref_from            : self.ref_from
                    }

                    if(self.state.create_acc){
                        post_params['create_acc'] = 1;
                    }
                    
                    if(self.state.create_license){
                        post_params['create_license'] = 1;
                    }

                    // POST request using fetch with error handling
                    var requestOptions = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(post_params)
                    };

                    if(ENV == 'dev'){
                        requestOptions['headers']['authorization'] = "Basic " + btoa(WEB_USERNAME + ":" + WEB_PASS)
                    }

                    fetch(this.home_url+'quotes/submit/new', requestOptions)
                    .then(async response => {

                        const data = await response.json();

                        if(data.status){
                            
                            $.append_notification('success','Quote submitted!');

                            setTimeout(() => {
                                window.location.href = data.redirect_url;
                            }, 500);
                        }
                        else{
                            self.form_submitting = false;
                            $.append_notification('error',data.message);
                        }
                    })
                    .catch(error => {
                        this.errorMessage = error
                        console.error('There was an error!', error);
                    });

                } catch (err) {
                    console.log(err);
                }
            }
        },

        async generateRecaptchaToken () {
            // (optional) Wait until recaptcha has been loaded.

            // const { executeRecaptcha, recaptchaLoaded } = this.recaptcha

            // await recaptchaLoaded()

            // let recaptcha_token = await executeRecaptcha('generate')

            // this.recaptcha_token = encodeURIComponent(recaptcha_token)

        },

        queryParamsParse () {

            let queryString = window.location.search,
                urlParams = new URLSearchParams(queryString),
                get_ref_ads = urlParams.get('ref_ads'),
                get_ref_from = urlParams.get('ref_from');
        
            if(get_ref_ads){
                this.ref_ads = get_ref_ads;
            }
            if(get_ref_from){
                this.ref_from = get_ref_from;
            }
        },
        handleWidgetId: function(widgetId){
            
            const { handleReset } = this.recaptcha;
            
            handleReset(widgetId);
        },
        handleErrorCalback: function(){
            this.state.recaptcha_token = ''
        },
        handleExpiredCallback: function(){
            this.state.recaptcha_token = ''
        },
        handleLoadCallback: function(response){
            this.state.recaptcha_token = response
        },
    },
    mounted: function(){

        this.queryParamsParse();
        
        var flashdata = {}

        const flashdataCollectionDiv = document.getElementsByClassName("frontpage_flashdata");

        if(flashdataCollectionDiv && flashdataCollectionDiv.length){
            let textContent = flashdataCollectionDiv[0].textContent;

            if(textContent)
                flashdata = JSON.parse(textContent);
        }

        if(Object.keys(flashdata).length){

            if(typeof flashdata.validation_errors != 'undefined'){
                Object.keys(flashdata.validation_errors).forEach(key => {
                    $.append_notification('error',flashdata.validation_errors[key])
                });
            }


            if(typeof flashdata.user_data.first_name != 'undefined'){
                this.state.first_name = flashdata.user_data.first_name
            }
            if(typeof flashdata.user_data.last_name != 'undefined'){
                this.state.last_name = flashdata.user_data.last_name
            }
            if(typeof flashdata.user_data.email != 'undefined'){
                this.state.email = flashdata.user_data.email
            }
            if(typeof flashdata.user_data.company != 'undefined'){
                this.state.company = flashdata.user_data.company
            }
            if(typeof flashdata.user_data.country != 'undefined'){
                this.state.country = flashdata.user_data.country
            }
            if(typeof flashdata.user_data.app_name != 'undefined'){
                this.state.app_name = flashdata.user_data.app_name
            }
            if(typeof flashdata.user_data.password != 'undefined'){
                this.state.password = flashdata.user_data.password
            }
            if(typeof flashdata.user_data.confirm_password != 'undefined'){
                this.state.confirm_password = flashdata.user_data.confirm_password
            }
            if(typeof flashdata.user_data.heard_about_us != 'undefined'){
                this.state.heard_about_us = flashdata.user_data.heard_about_us
            }
        }

    }
};
</script>